import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import UserSearch from '@/components/UsersSearch';
import UserDetail from '@/components/UsersSearch/components/UserDetail';
import { UserType } from '@/types/schema';

import { classes } from '../styles';

interface ManagerSearchProps {
  defaultUser?: UserType;
  error?: string | null;
  excludedUsers?: string[];
  initalValue?: string | null;
  reportsToUserId?: string | null;
  onChange: (value?: string) => void;
  className?: string;
  size?: 'large' | 'medium';
}

function ManagerSearch({
  defaultUser,
  error,
  excludedUsers,
  onChange,
  initalValue,
  reportsToUserId,
  className,
  size,
}: ManagerSearchProps) {
  const { t } = useTranslation();

  return (
    <UserSearch
      className={className}
      classes={classes}
      defaultUser={defaultUser}
      error={!!error}
      excludedUsers={excludedUsers}
      initalValue={initalValue}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      placeholder={t('Admin:InviteStaff.ReportsToPlaceholder')}
      renderOption={(user: UserType) => {
        return (
          <UserDetail
            key={user.id}
            endAdornment={
              user.id === reportsToUserId ? (
                <CheckMark className="h-20 w-20" fillColorToken="icon-active" />
              ) : null
            }
            showEmail={false}
            user={user}
          />
        );
      }}
      size={size}
      onChange={onChange}
    />
  );
}

export default ManagerSearch;
